import React, {useEffect, useState} from 'react';
import FinishTick from '../../Assets/SVG/FinishTick';
import {isMobile} from 'react-device-detect';
import BtnWhiteBlackBorderBigSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {buildUrlAndOpenSameWindow} from '../../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../../Config';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {stageEnums} from '../../Assets/VolteCheckVariables';

const ActiveStage = (props) => {
  const disclaimerText = isMobile ? (
    <p className='disclaimerText'>
      *{window.Config.brand_Name_HE} עושה את מירב המאמצים לספק את המידע המעודכן <br />
      והאמין ביותר, אך הוא נועד לנוחות בלבד ואינו מובטח כמדויק בכל <br />
      עת. על מנת לבדוק אם מכשירך מתאים ועומד ביכולות דור 4/5, <br />
      עליך לוודא זאת מול יצרן המכשיר.
    </p>
  ) : (
    <p className='disclaimerText'>
      *{window.Config.brand_Name_HE} עושה את מירב המאמצים לספק את המידע המעודכן והאמין ביותר, אך הוא נועד לנוחות בלבד ואינו מובטח כמדויק בכל <br />
      עת. על מנת לבדוק אם מכשירך מתאים ועומד ביכולות דור 4/5, עליך לוודא זאת מול יצרן המכשיר.
    </p>
  );
  return (
    <>
      <FinishTick />
      <div className='headBox'>
        <p className='heading'>
          מעולה,
          <br />
          המכשיר שלך תומך
        </p>
        <p className='subHeading'>עכשיו אפשר ליהנות משיחות{isMobile ? <br /> : null} באיכות גבוהה וחיבור מהיר</p>
      </div>
      {disclaimerText}
      {props.isAuthMode && (
        <div className='finishFooter'>
          {props.subscribersByProduct?.Cellular?.length > 1 && (
            <BtnSubmit
              className='mb-12'
              text={'חזרה לבחירת מנוי'}
              onclick={() => {
                props.setStage(stageEnums.selectSubscriber);
              }}
            />
          )}
          <BtnWhiteBlackBorderBigSize
            text='לאזור האישי'
            onclick={() => {
              buildUrlAndOpenSameWindow(Config.lobbyUrl);
            }}
          />
        </div>
      )}
    </>
  );
};

export default ActiveStage;
